import React from 'react';

function Factures() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-blue-700 mb-4">Factures</h1>
      <p className="text-gray-600">Ici s'afficheront tes factures !</p>
    </div>
  );
}

export default Factures;
